import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../../handlers/http-responses-handler';
import { BaseDataService } from '../base.data.service';
import { Injectable } from '@angular/core';
import { BadgeDefinitionDTO } from '../../interfaces/gamification/badge-definition.dto';
import { BadgeProgressDTO } from '../../interfaces/gamification/badge-progress.dto';
import { BadgeProgressDataDTO } from '../../interfaces/gamification/badge-progress-data.dto';

@Injectable({
  providedIn: 'root',
})
export class BadgeService extends BaseDataService {
  url = '/api/badges';
  entityTitle = 'Badges';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getBadgeDefinitions(): Promise<BadgeDefinitionDTO[]> {
    return this.handleRequest<BadgeDefinitionDTO[]>(
      this.http.get<BadgeDefinitionDTO[]>(`${this.url}/definitions`),
      this.handlersFactory.getForReadAll(),
    );
  }

  getBadgeProgress(): Promise<BadgeProgressDTO> {
    return this.handleRequest<BadgeProgressDTO>(
      this.http.get<BadgeProgressDTO>(`${this.url}/progress`),
      this.handlersFactory.getForReadAll(),
    );
  }
}
